<template>
  <div
    class="align-center background-color-white d-flex flex-column py-10 px-7"
  >
    <StorefrontImage class="mb-4" size="large" />
    <div class="font-size-lg font-weight-semibold mb-4 text-center">
      Reset Password
    </div>
    <ResetPasswordRequestConfirmation v-if="confirm" :closeAuth="closeAuth" />
    <div v-else>
      <div class="mb-5">
        Enter your email address to request a password reset
      </div>
      <v-form
        ref="form"
        v-model="valid"
        class="full-width"
        @submit.stop.prevent="resetPasswordRequest"
      >
        <EmailInput :email="email" :update="update" autofocus />
        <v-btn
          color="success"
          :disabled="!valid"
          type="submit"
          block
          large
          rounded
        >
          <div class="font-size-md font-weight-semibold text-capitalize">
            submit
          </div>
        </v-btn>
      </v-form>
    </div>
  </div>
</template>

<script>
import EmailInput from "@/components/Inputs/Email.vue";
import ResetPasswordRequestConfirmation from "@/components/Auth/ResetPasswordRequest/Confirmation.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "PasswordRequest",
  components: { EmailInput, ResetPasswordRequestConfirmation, StorefrontImage },
  data() {
    return {
      confirm: false,
      email: null,
      valid: true,
    };
  },
  methods: {
    async resetPasswordRequest() {
      this.$refs.form.validate();
      if (!this.valid) {
        return;
      }
      await this.$store.dispatch("auth/requestPasswordRestore", {
        email: this.email,
      });
      this.confirm = true;
      this.scrollToTop();
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    update(name, val) {
      this[name] = val;
    },
  },
  props: { closeAuth: Function },
};
</script>
